import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Endpoints} from "../../customs/endpoints";
import {CommonResponse} from "../../customs/_models/Response";
import {map, Observable} from "rxjs";
import { AppUserDTO } from '../../customs/_models/userDTO';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {


  constructor(private http : HttpClient,
              private endPoints : Endpoints) { }

    
    private apiUrl = `${environment.base_url}/api/users`; 
  
    // Récupérer tous les utilisateurs
    getUsers(): Observable<CommonResponse> {
      return this.http.get<CommonResponse>(this.apiUrl);
    }
    getPreleveurs(): Observable<CommonResponse> {
      return this.http.get<CommonResponse>(`${this.apiUrl}/preleveurs`);
    }
    
    /*getUsers(): Observable<any[]> {
      return this.http.get<CommonResponse>(this.apiUrl).pipe(
        map(response => response.data)  // Extraire uniquement les utilisateurs depuis `data`
      );
    }*/
    
    
    findAllShorts() : Observable<CommonResponse>{
      return this.http.get<CommonResponse>(`${this.apiUrl}/shorts`)
    }
    // Récupérer un utilisateur par ID
    getUserById(userId: number): Observable<AppUserDTO> {
      return this.http.get<{ status: boolean, message: string, data: AppUserDTO }>(`${this.apiUrl}/${userId}`)
        .pipe(
          map(response => response.data) // Correction : extraire `data`
        );
  }
  
    // Créer un nouvel utilisateur
    createUser(data: FormData): Observable<any> {
      return this.http.post(`${this.apiUrl}/create_users`, data);
    }
    private baseUrl = `${environment.base_url}/api/auth`; // Remplace par ton vrai backend URL

forgotPassword(email: string): Observable<any> {
  return this.http.post(`${this.baseUrl}/forgot-password`, { email });
}


  resetPassword(token: string, newPassword: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/reset-password`, { token, newPassword });
  }
  
    // Mettre à jour un utilisateur
    updateUser(id: number, formData: FormData): Observable<any> {
      return this.http.put(`${this.apiUrl}/update_user/${id}`, formData);
    }
  
    // Supprimer un utilisateur
    deleteUser(id: number): Observable<void> {
      return this.http.delete<void>(`${this.apiUrl}/delete_user/${id}`);
    }

    getCurrentUserFromSession(): AppUserDTO | null {
      const userData = sessionStorage.getItem('user'); 
      return userData ? JSON.parse(userData) : null;
    }
    
}
